import React, { useEffect, useState } from 'react';
import {
  StyledBackColorFill, StyledBarWrapper, StyledColorFill, StyledSinglebar
} from './styles';

const ProgressBar = ({
  slide, setSlide, handleTimeInterval, intervalId, clickable, color, homePage,
  pagination, length, contributionCard
}) => {
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const barArray = length ? Array(length).fill('') : ['', '', ''];

  useEffect(() => {
    setSlide(slide === length ? 0 : slide);
    if (slide === length) {
      setTimeout(() => {
        setIsFirstLoad(true);
        setTimeout(() => {
          setIsFirstLoad(false);
        }, 1);
      }, 4000);
    }
  }, [slide]);

  useEffect(() => {
    setIsFirstLoad(false);
    if (!contributionCard) {
      handleTimeInterval();
    }
    return () => clearInterval(intervalId);
  }, []);

  return (
    <StyledBarWrapper homePage={homePage} pagination={pagination}>
      {barArray.map((item, idx) => (
        <StyledSinglebar
          idx={idx}
          homePage={homePage}
          onClick={() => {
            if (clickable) {
              setSlide(idx);
              if (!contributionCard) {
                handleTimeInterval();
              }
            }
          }}
          size={{ mobile: 1 / 3 }}
        >
          <StyledBackColorFill homePage={homePage} pagination={pagination}>
            <StyledColorFill
              className={idx === slide && !isFirstLoad ? 'active' : 'unactive'}
              color={color}
              homePage={homePage}
              pagination={pagination}
            />
          </StyledBackColorFill>
        </StyledSinglebar>
      ))}
    </StyledBarWrapper>
  );
};

export default ProgressBar;
